export const defaultCurrencyId = 'usd';
export const defaultCurrencySymbol = '$';
